module.exports = __webpack_public_path__ + "img/06@2x.5bf74d98.png";